module.exports = __webpack_public_path__ + "img/BE.78b2c2d1.svg";